import * as React from 'react';
import * as ReactDOM from 'react-dom';
import store from './store';
import { App } from './App';
import Api from "./api";

// --

const appDomNode = document.getElementById('app');
ReactDOM.render(React.createElement(App, { api : Api, store }), appDomNode);
